import { Component, Input } from '@angular/core';
import { NgFor } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { PQRTamanhoTurmaDto } from '../../dtos';

@Component({
  selector: 'app-dialog-pqr-padrao-tamanho-das-turmas',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, NgFor, TabelaComponent],
  templateUrl: './dialog-pqr-padrao-tamanho-das-turmas.component.html',
  styleUrl: './dialog-pqr-padrao-tamanho-das-turmas.component.scss',
})
export class DialogPqrPadraoTamanhoDasTurmasComponent {
  @Input() dadosTabela: PQRTamanhoTurmaDto[] = [];

  get etapas(): number[] {
    const etapasUnicas = new Set(this.dadosTabela.map(d => d.etapaEnsino.codEtapaEnsino));
    return Array.from(etapasUnicas).sort((a, b) => a - b);
  }

  // Busca dados de uma etapa e localização específica
  obterDados(codEtapa: number, codLocalizacao: number): PQRTamanhoTurmaDto | undefined {
    return this.dadosTabela.find(
      d => d.etapaEnsino.codEtapaEnsino === codEtapa &&
        d.tipoLocalizacao.codTipoLocalizacao === codLocalizacao
    );
  }
}
